import React from "react";
import "./PlotSizes.css";
import plBgImg from "../../assets/imgs/plBgImg.jpg";
import downImg from "../../assets/imgs/downImg.png";

export default function PlotSizes() {
  return (
    <div className="psMn" style={{ backgroundImage: `url(${plBgImg})` }} id="plotsizes">
      <div className="psBox">
        <h2>Plot Sizes</h2>

        <h3>ARVIND SMARTSPACES – RESIDENTIAL PLOTS AT AJWA ROAD, VADODARA</h3>

        <h5>
          PREMIUM PLOTTED DEVELOPMENT | BUILD UP TO 3 FLOORS | GATED COMMUNITY LIVING
        </h5>

        <p className="psDesc">
          Discover Arvind Plots Vadodara, a premium plotted development located on Ajwa Road —
          offering unmatched connectivity, high investment potential, and a lifestyle wrapped in nature.
          Secure a plot that brings together long-term value, luxury living, and promising returns.
          Build your dream home in a community designed for families to grow and celebrate life.
        </p>

        <div className="psTable">
          <div className="psTHead">
            <p>UNIT TYPE</p>
            <p>PLOT SIZE (AREA)</p>
            <p>PRICE</p>
          </div>

          <div className="psTRow">
            <p>Residential Plot</p>
            <p>150 – 250 sq.yards</p>
            <p>₹ on request</p>
          </div>

          <div className="psTRow">
            <p>Residential Plot</p>
            <p>150 – 450 sq.yards</p>
            <p>₹ on request</p>
          </div>
        </div>

        <button className="psBtn">
          <img src={downImg} alt="download" /> DOWNLOAD PRICE LIST
        </button>
      </div>
    </div>
  );
}
